// @flow
import type { ReportState } from 'types';
export const ellipsify = (longText: string, length: number = 100): string => {
  if (longText.length < length + 4) {
    return longText;
  }

  let shortText = longText.substr(0, length);
  let i = shortText.length;
  while (longText.charAt(i) !== ' ' && i < longText.length) {
    shortText += longText.charAt(i);
    i += 1;
  }

  return `${shortText.trim()} ...`;
};

const STATES = {
  new: 'NEU',
  'in-progress': 'IN ARBEIT',
  finished: 'ERLEDIGT',
  declined: 'ABGELEHNT',
  deleted: 'GELÖSCHT',
};

export const translateStateToHuman = (state: ReportState): string => {
  return STATES[state];
};



// WEBPACK FOOTER //
// ./src/utils/text.js